import { createElement } from 'react'
import { toast, ToastOptions } from 'react-toastify'
import { CircleAlert, CircleCheck, Info } from 'lucide-react'
import { logError } from 'lib/logging'
import { ObjectId } from 'lib/ObjectId'

// Toasts are styled as theme cards in tailwind.css (.Toastify__*), so the
// container stays on the default "light" theme and follows dark mode itself.
const properties: ToastOptions = {
  position: `bottom-center`,
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  icon: false,
}

export function notify(message: string, toastId: string = ObjectId()): void {
  toast(message, { ...properties, toastId, icon: () => createElement(Info, { size: 18 }) })
}

export function notifySuccess(message: string, toastId: string = ObjectId()): void {
  toast.success(message, { ...properties, toastId, icon: () => createElement(CircleCheck, { size: 18 }) })
}

export function notifyError(message: string, toastId: string = ObjectId()): void {
  logError(`notify error`, new Error(message))
  toast.error(message, {
    ...properties,
    type: `error`,
    toastId,
    autoClose: 5000,
    icon: () => createElement(CircleAlert, { size: 18 }),
  })
}
